<div class="flex h-full flex-col">
  <div class="bg-m0 flex flex-grow overflow-y-auto rounded shadow">
    <div class="divide-s500 ml-5 mr-5 mt-14 flex w-full flex-col divide-y">
      <div
        class="text-s1 mb-3 mr-5 flex h-6 flex-row space-x-5 text-base font-semibold"
      >
        <div class="flex w-12"></div>
        <div class="flex w-1/4">Chart</div>
        <div class="flex flex-1 flex-row space-x-5">
          <div class="flex flex-1">Chart Id</div>
          <div class="flex flex-1">Model</div>
          <div class="flex flex-1">Space</div>
          <div class="flex flex-1">Access Roles</div>
          <div class="flex flex-1">Author</div>
        </div>
      </div>

      <div
        *ngIf="filteredCharts?.length > 0"
        class="h-2 flex-1 overflow-y-auto"
      >
        <div
          *ngFor="let item of filteredCharts; let i = index; trackBy: trackByFn"
          class="hover:bg-m50 bg-m0 flex flex-row hover:cursor-pointer"
          [ngStyle]="
            item.chartId !==
              filteredCharts[filteredCharts.length - 1].chartId && {
              'border-bottom-width': '1px'
            }
          "
          [ngClass]="{
            'mt-2': i === 0,
            'mb-5': i === filteredCharts.length - 1,
            'border-s300':
              item.chartId !== filteredCharts[filteredCharts.length - 1].chartId
          }"
        >
          <div class="flex-grow flex-col text-base">
            <div
              class="text-s1 group mr-5 flex w-full flex-row items-start space-x-5 rounded pt-1 focus:outline-none"
              (click)="navigateToChart(item)"
            >
              <div class="flex w-12 pl-3">
                <div class="invisible flex group-hover:visible">
                  <m-chart-options
                    [chart]="item"
                    [isHoverM]="false"
                  ></m-chart-options>
                </div>
              </div>

              <div
                class="flex w-1/4 select-none flex-row items-start truncate pb-[5px] pt-[6px]"
              >
                <img class="h-6 w-6" [src]="item.iconPath" />

                <span class="ml-3 select-none truncate pt-[1px]">
                  {{ !!item.title ? (item.title | capitalize) : item.chartId }}
                </span>
              </div>

              <div class="flex flex-1 flex-row space-x-5 text-base">
                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span class="truncate"> {{ item.chartId }} </span>
                </div>

                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span class="truncate">{{ item.modelLabel }}</span>
                </div>

                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span class="truncate">
                    {{ item.spaceFullTitle }}
                  </span>
                </div>

                <div
                  class="flex flex-1 flex-wrap truncate pb-[9px] pt-[7px] text-base"
                >
                  <span
                    *ngFor="let accessRole of item.accessRolesCombined"
                    class="mr-2 truncate rounded px-2"
                    [ngClass]="{
                      'bg-green-200 text-green-700': accessRole.isDirect,
                      'bg-slate-200 text-slate-700': !accessRole.isDirect
                    }"
                  >
                    {{ accessRole.role }}
                  </span>
                </div>

                <div
                  class="flex flex-1 items-start truncate pb-[9px] pt-[7px] focus:outline-none"
                >
                  <span>
                    {{ item.author }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="h-11"></div>
        </div>
      </div>

      <div
        class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
        *ngIf="filteredCharts?.length === 0"
        >No Charts</div
      >
    </div>
  </div>
</div>

<div *ngIf="nav$ | async"></div>
<div *ngIf="isExplorer$ | async"></div>
<div *ngIf="filteredCharts$ | async"></div>
